import { render, staticRenderFns } from "./ContactViewItem.vue?vue&type=template&id=89ee12da&scoped=true&"
import script from "./ContactViewItem.vue?vue&type=script&lang=js&"
export * from "./ContactViewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ee12da",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VIcon,VRating})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89ee12da')) {
      api.createRecord('89ee12da', component.options)
    } else {
      api.reload('89ee12da', component.options)
    }
    module.hot.accept("./ContactViewItem.vue?vue&type=template&id=89ee12da&scoped=true&", function () {
      api.rerender('89ee12da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Contact/ContactViewItem.vue"
export default component.exports